import { useLocation, useNavigate } from "react-router-dom"

import { Box, Button } from "@mui/material"

import kwikScoutLogo from "../assets/kwik-scout-logo.png"
import LandingButton from "./landing/LandingButton"

const LandingHeader = () => {
    const location = useLocation()
    const navigate = useNavigate()

    const showLandingNavItems = !["/login", "/teste_agora"].includes(location.pathname)

    const navItems = [
        { label: "Como funciona", target: "como-funciona" },
        { label: "Funcionalidades", target: "funcionalidades" },
        { label: "Preços", target: "planos" },
        { label: "Perguntas frequentes", target: "faq" },
    ]

    const scrollTo = (id) => {
        const el = document.getElementById(id)
        if (el) {
            el.scrollIntoView({ behavior: "smooth" })
        }
    }

    return (
        <Box component="header" className="landing-header-shell">
            <Box className="landing-header-inner">
                <Box className="landing-header-brand-wrap">
                    <Box
                        component="button"
                        type="button"
                        onClick={() => navigate("/")}
                        className="landing-header-brand"
                    >
                        <Box
                            component="img"
                            src={kwikScoutLogo}
                            alt="Kwik Scout"
                            className="landing-header-logo"
                        />
                    </Box>
                </Box>

                <Box component="nav" className="landing-header-nav">
                    {showLandingNavItems && navItems.map((item) => (
                        <Button
                            key={item.target}
                            onClick={() => scrollTo(item.target)}
                            disableRipple
                            className="landing-header-nav-button"
                        >
                            {item.label}
                        </Button>
                    ))}
                    <Button
                        key='login-button'
                        onClick={() => navigate("/login")}
                        disableRipple
                        className="landing-header-nav-button"
                    >
                        Login
                    </Button>
                </Box>

                <Box className="landing-header-cta-wrap">
                    <Button
                        onClick={() => navigate("/login")}
                        disableRipple
                        className="landing-header-login-mobile"
                    >
                        Login
                    </Button>
                    <LandingButton
                        onClick={() => navigate("/teste_agora")}
                        variant="header"
                        size="header"
                    >
                        Teste grátis
                    </LandingButton>
                </Box>
            </Box>
        </Box>
    )
}

export default LandingHeader
